<!--
 * @Author: cn1994
 * @Date: 2023-09-07 10:21:10
 * @LastEditors: cn1994
 * @LastEditTime: 2023-11-01 14:26:20
 * @Description: file content
-->
<template>
  <div class="ls-mobile-preview-phone-component">
    <div class="top">
      <div class="left">
        <img class="inst_logo" :src="instInfo.instLogo">
        <div class="title-subject">
          <span class="inst_title">{{ instInfo.instTitle }}</span>
          <div class="subject-cell">
            <span class="subject">{{ instInfo.subject }}</span>
          </div>
        </div>
        
      </div>
      <div class="right">
        <div class="user-cell">
          <img class="avatar" :src="userInfo.avatar">
          <span class="name">{{ userInfo.name }}</span>
        </div>
      </div>
    </div>
    <div class="bottom" @mousewheel="handelMousewheel">
      <img v-if="userInfo.role == 'groupAdmin'" class="moer" src="https://cdnws.51tyty.com/lstyty/file/2023/11/28/9c509e66a3e72d4919d7d4c9a435e148.png">
      <div class="left">
        <div
          v-for="item in leftConfig"
          :key="item.id"
          class="row"
        >
          <img class="icon" :src="item.icon">
          <span class="title">{{ item.title }}</span>
        </div>
      </div>
      <plateComponent :plateConfig="plateConfig" :role="role" />
    </div>
  </div>
</template>

<script>
import plateComponent from './plate.vue'

export default {
  components: {
    plateComponent
  },
  props: {
    instInfo: {
      type: Object,
    },
    userInfo: {
      type: Object,
    },
    topConfig: {
      type: Array,
      default: []
    },
    leftConfig: {
      type: Array,
      default: []
    },
    role: {
      type: String,
    },
    plateConfig: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return  {

    }
  },
  methods: {
    handelMousewheel(e) {
      let dom = document.querySelector('.bottom')
      let ua = window.navigator.userAgent
      let isMac = ua.includes('OS X')
      if (isMac) {
        if (e.deltaX > 0) {
          // 往左划
          dom.scrollLeft += 20
        } else {
          // 往右划
          dom.scrollLeft -= 20
        }
      } else {
        if (e.deltaY > 0) {
          // 往左划
          dom.scrollLeft += 100
        } else {
          // 往右划
          dom.scrollLeft -= 100
        }
      }
      
      e.preventDefault()
    }
  }
}
</script>

<style lang="less" scoped>
.ls-mobile-preview-phone-component {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(5px);
  .top {
    height: 80px;
    max-width: 720px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 0 30px;
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      .inst_logo {
        width: 54px;
        height: 54px;
        border-radius: 50%;
      }
      .title-subject {
        display: flex;
        flex-direction: column;
        margin-left: 6px;
        .inst_title {
          font-size: 14px;
          color: #333;
          font-weight: 600;
        }
        .subject-cell {
          background-color: rgba(255,255,255,0.5);
          height: 24px;
          box-shadow: inset 0px 0px 7px 2px rgba(255,255,255,0.5);
          border-radius: 28px;
          padding: 10px 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          width: fit-content;
          margin-top: 6px;
          .subject {
            font-size: 12px;
            color: #333;
            line-height: 17px;
          }
        }
      }
    }
    
    
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      
      .user-cell {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 21px;
        .avatar {
          width: 39px;
          height: 39px;
          border-radius: 50%;
        }
        .name {
          margin-top: 5px;
          font-size: 10px;
          font-weight: 600;
          color: #333;
        }
      }
    }
  }
  .bottom {
    flex: 1;
    display: flex;
    align-items: center;
    padding-bottom: 9px;
    overflow-x: scroll;
    .moer {
      width: 15px;
      height: 78px;
    }
    .left {
      width: 95px;
      height: 268px;
      background: rgba(255, 255, 255, 0.3);
      box-shadow: inset 0px 0px 7px 2px rgba(255,255,255,0.6);
      border-radius: 10px;
      backdrop-filter: blur(10px);
      display: flex;
      flex-direction: column;
      padding: 13px 8px;
      margin-left: 15px;
      
      .row {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon {
          width: 28px;
          height: 28px;
        }
        .title {
          flex: 1;
          font-size: 12px;
          color: #333;
          margin-left: 3px;
          word-break: keep-all;
          display: block;
          text-align: center;
        }
      }
    }
  }
}
</style>
